(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mvp-collection-tab"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Tab Button Switching
    var tabs = document.querySelectorAll('.mvp-tab-btn');
    var sliders = document.querySelectorAll('.mvp-cards-slider');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var selectedTab = this.getAttribute('data-tab');
        // Activate selected tab
        tabs.forEach(function(t) {
          t.classList.remove('active');
        });
        this.classList.add('active');
        // Show related slider
        sliders.forEach(function(slider) {
          slider.style.display = (slider.getAttribute('data-tab') === selectedTab) ? 'block' : 'none';
        });
      });
    });

    // Function to initialize slider dots and scroll behavior on tablet/mobile
    function initSlider(slider) {
      var container = slider.querySelector('.mvp-cards-container');
      var dotsContainer = slider.querySelector('.mvp-dots');
      var cards = slider.querySelectorAll('.mvp-card');
      var totalCards = cards.length;
      var viewportWidth = window.innerWidth;
      var cardsPerView = 4; // default for desktop

      if(viewportWidth <= 750) {
        cardsPerView = viewportWidth <= 420 ? 1 : 2;
      }

      // Calculate slide count (only for slider mode)
      var slideCount = totalCards - cardsPerView + 1;
      if(slideCount < 1) { slideCount = 1; }

      if(viewportWidth <= 750) {
        dotsContainer.innerHTML = '';
        // Compute slide width based on container width and cardsPerView
        var slideWidth = container.offsetWidth / cardsPerView;
        for (var i = 0; i < slideCount; i++) {
          var dot = document.createElement('div');
          dot.classList.add('mvp-dot');
          if(i === 0) { dot.classList.add('active'); }
          dot.setAttribute('data-index', i);
          dotsContainer.appendChild(dot);
          dot.addEventListener('click', function() {
            var index = this.getAttribute('data-index');
            container.scrollTo({
              left: index * slideWidth,
              behavior: 'smooth'
            });
          });
        }
        container.addEventListener('scroll', function() {
          var index = Math.round(container.scrollLeft / slideWidth);
          var dots = dotsContainer.querySelectorAll('.mvp-dot');
          dots.forEach(function(dot) { dot.classList.remove('active'); });
          if(dots[index]) { dots[index].classList.add('active'); }
        });
      } else {
        dotsContainer.innerHTML = '';
      }
    }

    // Initialize all sliders
    function initAllSliders() {
      sliders.forEach(function(slider) {
        initSlider(slider);
      });
    }
    initAllSliders();
    window.addEventListener('resize', initAllSliders);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mvp-page-footer"] && !window.DesignMode) return;
  try {
    
// Hover effect for certification logos
document.querySelectorAll('.certification-item img').forEach(img => {
  img.addEventListener('mouseover', () => {
    img.style.transform = 'scale(1.1)';
  });
  img.addEventListener('mouseout', () => {
    img.style.transform = 'scale(1)';
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mvp-page-left-tabs-"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  class MVPTabsController {
    constructor(sectionId) {
      this.section = document.getElementById(sectionId);
      if (!this.section) return;

      this.mainImage = this.section.querySelector('.left-image-container img');
      this.defaultImageUrl = this.mainImage ? this.mainImage.src : '';

      // Gather all the buttons (desktop + mobile)
      this.buttons = this.section.querySelectorAll('.left-cut-button');

      this.init();
    }

    init() {
      // Add event listeners for click/hover
      this.buttons.forEach(button => {
        button.addEventListener('click', (e) => this.handleClick(e, button));
        button.addEventListener('mouseover', () => this.handleHover(button));
        button.addEventListener('mouseout', () => this.handleMouseOut());
      });
    }

    handleClick(event, button) {
      event.preventDefault();
      const idx = button.getAttribute('data-index');

      // Deactivate all buttons
      this.buttons.forEach(b => b.classList.remove('active'));

      // Activate the group of matching data-index
      this.section
        .querySelectorAll(`.left-cut-button[data-index="${idx}"]`)
        .forEach(b => b.classList.add('active'));

      // Change main image
      this.setMainImage(button.getAttribute('data-image'));
    }

    handleHover(button) {
      // On hover, change image to hovered button's image
      this.setMainImage(button.getAttribute('data-image'));
    }

    handleMouseOut() {
      // On mouse out, revert to the currently active button (if any)
      const activeBtn = this.section.querySelector('.left-cut-button.active');
      const newSrc = activeBtn
        ? activeBtn.getAttribute('data-image')
        : this.defaultImageUrl;
      this.setMainImage(newSrc);
    }

    setMainImage(url) {
      if (!this.mainImage || !url || this.mainImage.src === url) return;

      // Fade out
      this.mainImage.style.opacity = '0';

      // Preload the new image
      const temp = new Image();
      temp.onload = () => {
        this.mainImage.src = url;
        this.mainImage.style.opacity = '1';
      };
      temp.onerror = () => {
        console.error('Image failed:', url);
        this.mainImage.src = this.defaultImageUrl;
        this.mainImage.style.opacity = '1';
      };
      temp.src = url;
    }
  }

  // Initialize controller for each matching section
  document.querySelectorAll('[id^="mvp-tabs-"]').forEach(sec => {
    new MVPTabsController(sec.id);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Raj-4tab-selection"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Tab Button Switching
  var tabs = document.querySelectorAll('.raj-tab-btn');
  var sliders = document.querySelectorAll('.raj-cards-slider');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var selectedTab = this.getAttribute('data-tab');
      // Activate selected tab
      tabs.forEach(function(t) {
        t.classList.remove('active');
      });
      this.classList.add('active');
      // Show related slider
      sliders.forEach(function(slider) {
        slider.style.display = (slider.getAttribute('data-tab') === selectedTab) ? 'block' : 'none';
      });
    });
  });

  // Function to initialize slider dots and scroll behavior for mobile only
  function initSlider(slider) {
    var container = slider.querySelector('.raj-cards-container');
    var dotsContainer = slider.querySelector('.raj-dots');
    var cards = slider.querySelectorAll('.raj-card');
    var totalCards = cards.length;
    var viewportWidth = window.innerWidth;

    // Only initialize slider for mobile (420px and below)
    if (viewportWidth <= 420) {
      var cardsPerView = 1;
      var slideWidth = container.offsetWidth / cardsPerView;
      var slideCount = Math.max(1, totalCards - cardsPerView + 1);

      dotsContainer.innerHTML = '';
      for (var i = 0; i < slideCount; i++) {
        var dot = document.createElement('div');
        dot.classList.add('raj-dot');
        if (i === 0) { dot.classList.add('active'); }
        dot.setAttribute('data-index', i);
        dotsContainer.appendChild(dot);
        dot.addEventListener('click', function() {
          var index = this.getAttribute('data-index');
          container.scrollTo({
            left: index * slideWidth,
            behavior: 'smooth'
          });
        });
      }
      container.addEventListener('scroll', function() {
        var index = Math.round(container.scrollLeft / slideWidth);
        var dots = dotsContainer.querySelectorAll('.raj-dot');
        dots.forEach(function(dot) { dot.classList.remove('active'); });
        if (dots[index]) { dots[index].classList.add('active'); }
      });
    } else {
      dotsContainer.innerHTML = ''; // Clear dots for tablet and desktop
    }
  }

  // Initialize all sliders
  function initAllSliders() {
    sliders.forEach(function(slider) {
      initSlider(slider);
    });
  }
  initAllSliders();
  window.addEventListener('resize', initAllSliders);
});

  } catch(e) { console.error(e); }
})();
})();
